import React, { useEffect, useRef, useState } from "react";
import Preview from "../Preview";

const Vimeo = ({ url, autoplay, previewUrl, rawUrl }) => {
  const [showPreview, setshowPreview] = useState(true);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const loadOnce = useRef(false);

  useEffect(() => {
    setshowPreview(!autoplay);
  }, []);

  const playVedio = () => {
    setshowPreview(false);
    if (iframeRef.current) {
      iframeRef.current.src = rawUrl + "&autoplay=1&mute=0";
    }
  };

  return (
    <div className="video-wrapper">
      <div
        className="full-width"
        style={{ display: showPreview ? "block" : "none" }}
      >
        <Preview url={previewUrl} playVedio={playVedio} />
      </div>

      <iframe
        ref={iframeRef}
        data-ot-ignore
        style={{
          display: showPreview ? "none" : "block",
          height: showPreview ? "0" : "100vh",
          minHeight: showPreview ? "0" : "100vh",
        }}
        onLoad={() => {
          if (autoplay && !loadOnce.current) {
            loadOnce.current = true;
          }
        }}
        allowFullScreen
        allow="autoplay"
        src={autoplay ? url : ""}
        className="optanon-category-VID1 full-width black-background"
      ></iframe>
    </div>
  );
};

export default Vimeo;
